






















import inputMixin from 'library/mixins/input-mixin'

export default
	mixins: [inputMixin]

	props:
		allocations: Array
		loading: Boolean

	computed:

		# Make the options, removing the "delivery every" in the name
		options: -> @allocations.map ({ sellingPlan }) ->
			value: sellingPlan.name.replace /delivery every\s*/i, ''
			key: sellingPlan.id

	watch:
		state: (newVal) ->
			@$emit 'change', newVal

